import store from 'store'

const el = '[data-content=HoldetsLys]'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((HoldetsLysDOM)=>{
            const teamId = HoldetsLysDOM.dataset.teamid
            const lysposeFormUrl = HoldetsLysDOM.dataset.lysposeFormUrl
            
            store.commit('main/set_page_overlay_content_data',{ teamId, lysposeFormUrl })
        })
    }
}